<template>
  <div class="item">
    <i class="large cloud alternate middle aligned icon" :class="icon_class"></i>
    <div class="content">
      <div class="truncate">
        <strong>
        {{ task.name }}
        </strong>
        ({{ bytes_to_human(task.total) }})
      </div>
      <div class="description text-sm">
        <span v-if="task.failed">
          <span class="ui red text">
            {{ task_error }}
          </span>
          <a v-if="need_rename" class="text-blue-500" @click="show_modal('modal-retry-' + _uid)">
            重命名
          </a>
          <a v-else class="text-blue-500" @click="retry(task.name)">
            重试
          </a>
        </span>
        <span v-else-if="task.finished" class="text-green-600">已完成，用时{{ total_time }}</span>
        <span v-else>
          当前速度：
          <strong>
            {{ task.bps_human }}
          </strong>
          <span class="text-teal-500">
            {{ task.percent }}%
          </span>
        </span>
        <button class="close ml-1" @click="del" v-if="task.succeeded || task.failed" data-tooltip="清除任务">
          <i class="times icon"></i>
        </button>
      </div>
    </div>
    <div class="progress">
      <div :class="progclass" class="progress-bar" :style="{ width: task.percent + '%' }"></div>
    </div>
    <Modal :id="'modal-retry-' + _uid" @ok="retry(newname)">
      <div class="ui fluid input">
        <input id="retry-new-dir-name" name="retry-new-dir-name" v-model="newname" autofocus @keyup.esc="hide_modal('modal-retry-' + _uid)" @keyup.enter="retry(newname)" placeholder="新文件名" />
      </div>
    </Modal>
  </div>
</template>

<script>
import printf from 'printf'
import Modal from './modal.vue'

export default {
  name: 'TaskEntry',
  props: ['task'],
  components: {
    Modal,
  },
  data: function () {
    return {
      newname: this.suggested_newname(this.task.name),
    };
  },
  computed: {
    icon_class() {
      if (this.task.type == "upload") {
        return ["upload", "text-purple-700"];
      } else {
        return ["download", "text-blue-700"];
      }

    },
    total_time() {
      var secs = this.task.total_time / 1000;
      var hours = Math.floor(secs / 3600);
      var minutes = Math.floor((secs % 3600) / 60);
      var seconds = Math.floor(secs % 60);
      return printf("%02d:%02d:%02d", hours, minutes, seconds);
    },
    progclass() {
      switch (this.task.state) {
        case 'done':
          return ['bg-success'];
        case 'running':
          return ['bg-primary'];
        case 'failed':
          return ['bg-danger'];
      }
      return [];
    },
    task_error() {
      var e = this.task.error;
      if (!e) return "";
      switch (e.message) {
        case 'EEXIST':
          return "文件名冲突";
        default:
          return this.task.type == "upload" ? "上传失败" : "下载失败";
      }
    },
    need_rename() {
      return this.task.error.message == "EEXIST";
    }
  },
  methods: {
    suggested_newname(n) {
      var c = '(重命名)';
      var i = n.lastIndexOf('.');
      if (i < 0) return n + c;
      return n.slice(0, i) + c + n.slice(i);
    },
    task_icon(e) {
      switch (e.type) {
        case "upload":
          return ['fas', 'fa-angle-double-up'];
        case "download":
          return ['fas', 'fa-angle-double-down'];
      }
      return [];
    },
    retry(name) {
      this.task.retry(name);
      this.hide_modal('modal-retry-' + this._uid);
    },
    del() {
      this.$store.commit("delete_task", { task: this.task });
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
button:hover i.times.icon {
  color: red;
}
</style>
